import {
  CommunicationThreadBody,
  useCommunicationThreadTitle,
} from "@/components/communications/CommunicationThreadBody.tsx";
import {
  MainContentWrapper,
  SiteHeaderContent,
  ViewWrapper,
} from "@/components/layout/ViewWrapper.tsx";
import { useRoute } from "wouter";

/**
 * A conversation as its own page: the list of messages in an email or text
 * exchange, at `/communications/:id/thread`.
 *
 * The surface a conversation falls back to where there is no canvas to card it
 * onto — mobile, and any screen that mounts none. A row here navigates to the
 * message's own page, and the browser's back gesture returns to this list, which
 * is the same drill-down and back the canvas gives with a card and its Back
 * control.
 */
export const CommunicationThread = () => {
  const [, params] = useRoute("/communications/:id/thread");
  const id = params?.id;
  const title = useCommunicationThreadTitle(id);

  return (
    <ViewWrapper headerContent={<SiteHeaderContent includeBackButton title={title} />}>
      <MainContentWrapper>
        <div className="px-2 py-2">
          <CommunicationThreadBody communicationId={id} />
        </div>
      </MainContentWrapper>
    </ViewWrapper>
  );
};
